import Keys from '@/constant/key'
import { Interceptors } from './interceptors'
import { clearObjInvalidEl } from '@/utils/index'
// import router from '../../router'
// import Message from 'element-plus/lib/el-message/src/message'

export class HttpService {
    public axios: any
    public baseUrl:string = '/api'

    constructor () {
        // 获取 axios 实例
        this.axios = new Interceptors().getInterceptors()
    }

    /**
     * get 请求
     * @param url           请求地址
     * @param params        参数，包含 urlPrefix 区分请求接口地址
     * @param jwt           是否校验 token
     * @param version       版本，默认 1.0.0
    */
    public get(url:string, params:any = {}, jwt:boolean = true, version:string = '1.0.0') {
        // const url = `${service}/${version}/${modulename}/${operation}`
        const userInfo = localStorage.getItem('userInfo')
        const adminId = userInfo && JSON.parse(userInfo).id || ''
        const adminName = userInfo && JSON.parse(userInfo).username || ''
        const nickName = userInfo && JSON.parse(userInfo).nickName || ''
        const urlPrefix = params?.urlPrefix || this.baseUrl
        url = urlPrefix + url
        params = clearObjInvalidEl(params)
        const body = {
            ...params,
            user_id: adminId,
            user_name: adminName,
            nick_name: nickName
        }

        return new Promise((resolve, reject) => {
            this.axios.get(url, {
                headers: { isJwt: jwt },
                params: body
            }).then((res:any) => {
                this.resultHandle(res, resolve)
            }).catch((err:any) => {
                reject(err.message)
            })
        })
    }

    public post(url:string, params:any = {}, isFormData:boolean = false) {
        const userInfo = localStorage.getItem('userInfo')
        const adminId = userInfo && JSON.parse(userInfo).id || ''
        const adminName = userInfo && JSON.parse(userInfo).username || ''
        const nickName = userInfo && JSON.parse(userInfo).nickName || ''

        const urlPrefix = params?.urlPrefix || this.baseUrl
        url = urlPrefix + url

        let data:any
        if (isFormData) {
            data = new FormData()
            for (let key in params) {
                data.append(key, params[key])
            }
            data.append('user_id', adminId)
            data.append('user_name', adminName)
        } else {
            data = {
                ...params,
                user_id: adminId,
                user_name: adminName,
                nick_name: nickName
            }
        }
        return new Promise((resolve, reject) => {
            this.axios.post(url, data, {
                // headers: { isJwt: jwt } 
            }).then((res:any) => {
                this.resultHandle(res, resolve)
            }).catch((err:any) => {
                reject(err.message)
            })
        })
    }

    public resultHandle(res:any, resolve:any) {
        if (res.status === 200) {
            resolve(res.data)
        } else {
            this.errorHandle(res)
        }
    }

    public errorHandle(res:any) {
        // Message.warning(res.msg) // 统一弹服务端提示（错误提示信息由服务端在接口中返回）
        // 状态码判断
        switch (res.code) {
            case 10009:
                break;
            case 10008:
                break;
            default:
                console.log('---------> other error')
        }
    }
}